module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOCIgZmlsbCA9IiMwMTc2RkYiIHZpZXdCb3g9IjAgMCAxMSA4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik02LjEzMiA2LjA2NmEuODQ0Ljg0NCAwIDAgMS0xLjE4OC4wMDZMMS4yNTIgMi40NDZhLjg0NC44NDQgMCAxIDEgMS4xODMtMS4yMDRMNS41NDIgNC4yOCA4LjU2IDEuMjQ4QS44NDQuODQ0IDAgMSAxIDkuNzUyIDIuNDRsLTMuNjIgMy42MjZ6IiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/down-caret-blue.svg
// module id = Unpx
// module chunks = 89